import { render, staticRenderFns } from "./OriginItem.vue?vue&type=template&id=53884ada&scoped=true&"
import script from "./OriginItem.vue?vue&type=script&lang=js&"
export * from "./OriginItem.vue?vue&type=script&lang=js&"
import style0 from "./OriginItem.vue?vue&type=style&index=0&id=53884ada&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53884ada",
  null
  
)

export default component.exports